export const useFormattedDate = () => {
  const formattedDate = (date: string): string => {
    const updatedDate = new Date(date);
    return `${updatedDate.toLocaleDateString()} ${updatedDate.toLocaleTimeString()}`;
  };

  return { formattedDate };
};
